import { useEffect, useState, useContext } from 'react';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './cumulativeExpensesAgbk.css'
import { downloadAgbkCumulativeExpensesReport, fetchAgbkCumulativeExpensesReports } from 'services/agbkReportsServices';

const CumulativeExpensesAgbk = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchAgbkCumulativeExpensesReports(user)
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t(`pages_name.agbk_report_compliance_cumulative_expenses`)}>
      <Notification />
      <div className='cumulativeExpenses_titleComponent'>
        <h2>{t(`pages.agbk_cumulative_expenses.title`)}</h2>
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`agbk_cumulative_expenses_${file}.xlsx`}
              fetchData={downloadAgbkCumulativeExpensesReport}
              fetchDataParams={{ user, fileName: file }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default CumulativeExpensesAgbk;